import React from 'react'
import MaterialSymbol from '../material-symbol'

const Message = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="message" {...props} />
))

Message.displayName = 'Message'

export default Message
